const PDFURL = process.env.REACT_APP_PDF_URL;
export default PDFURL;
